import { isApiError } from '../../api';
import { adminErrorMessage } from './error-message';

/** Situação da conexão em palavras (o selo mostra isto, nunca só uma cor). */
export const STATUS_LABEL = {
  not_configured: 'Não configurado',
  awaiting_install: 'Aguardando a instalação no Bitrix',
  connected: 'Conectado',
  error: 'Com problema',
} as const;

/** Texto quando uma ação do Bitrix (salvar, testar, carregar opções) falha. O texto cru do Bitrix nunca chega aqui. */
export function bitrixErrorMessage(error: unknown, fallback: string): string {
  if (isApiError(error)) {
    if (error.code === 'bitrix_auth') {
      return 'O Bitrix recusou o acesso do aplicativo. No Bitrix, abra o aplicativo local e clique em Reinstalar no cartão do aplicativo.';
    }
    if (error.code === 'not_connected') return 'Instale o aplicativo no Bitrix antes de continuar.';
    if (error.code === 'missing_credentials') {
      return 'Digite o ID e a chave do aplicativo (o Bitrix os mostra depois de salvar o aplicativo) antes de ligar.';
    }
    if (error.code === 'bitrix_scope') return error.message; // diz quais permissões marcar
    if (error.code === 'missing_application_token') return error.message;
    if (error.code === 'https_required') return error.message;
    if (error.code === 'not_configured')
      return 'Informe primeiro os dados do aplicativo do Bitrix.';
    if (error.code === 'bitrix_rejected') return 'O Bitrix recusou o pedido.';
    // O servidor diz QUAL campo está errado (domínio, ID…), em português.
    if (error.code === 'bad_request') return error.message;
  }
  return adminErrorMessage(error, fallback);
}

/** Frase para o leitor de tela quando as opções são salvas. */
export const SETTINGS_SAVED_TEXT = 'Opções salvas.';

/** O motivo (`lastError`) do último problema ao preparar o Canal Aberto, em palavras. */
export function openlinesProblemText(code: string | null): string | null {
  switch (code) {
    case null:
      return null;
    case 'scope':
      return 'O Bitrix recusou o acesso ao Canal Aberto: no aplicativo local, marque as permissões "Canais Abertos" e "Bot de chat", salve e clique em Reinstalar no cartão do aplicativo (só salvar não repete a instalação).';
    case 'unavailable':
      return 'O Bitrix não respondeu. Tente de novo em instantes.';
    default:
      return 'O Bitrix recusou a configuração. Confira o aplicativo no Bitrix e tente de novo.';
  }
}

/** Por que os atalhos "Modelos de mensagem" e "Gravar áudio" não estão registrados no chat do Bitrix (o resto do Canal Aberto não depende deles). */
export function widgetProblemText(code: string | null): string | null {
  switch (code) {
    case null:
      return null;
    case 'scope':
      return 'O Bitrix não deixou registrar os atalhos "Modelos de mensagem" e "Gravar áudio" no chat. No aplicativo local, marque também as permissões "Integração de aplicativos" (placement) e "Chat e notificações" (im), salve, clique em Reinstalar no cartão do aplicativo e depois em Preparar no Bitrix. O resto do Canal Aberto funciona sem isso.';
    case 'unavailable':
      return 'O Bitrix não respondeu ao registrar os atalhos "Modelos de mensagem" e "Gravar áudio". Clique em Preparar no Bitrix de novo.';
    default:
      return `O Bitrix recusou registrar os atalhos "Modelos de mensagem" e "Gravar áudio" (${code}). O resto do Canal Aberto funciona sem eles.`;
  }
}

export const OPENLINES_APPLIED_TEXT = 'Canal Aberto preparado no Bitrix.';
export const OPENLINES_ON_TEXT = 'As conversas passam a ir para o chat do Bitrix.';
export const OPENLINES_OFF_TEXT = 'As conversas deixam de ir para o chat do Bitrix.';
export const HANDOFF_ON_TEXT =
  'Ligado: quando alguém assumir uma conversa de propósito no CladvApp, o bot da linha sai dela no Bitrix.';
export const HANDOFF_OFF_TEXT =
  'Desligado: o CladvApp não altera nada nas conversas do Bitrix; quem manda é a regra da linha.';
